import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CustomClub} from '../../../components/Club/Club';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import FloatButton from '../../../components/FloatButton/FloatButton';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import useSearchParam from '../../../hooks/useQueryParams';
import { getAllUserClubs } from '../../../service/clubUser';
import { getUser } from '../../../service/user';

import { useUserStore } from '../../../store/useUser';
import { main_color_50 } from '../../../styles/_variables';
import { getUserIdByPathname } from '../../../utils/user';

import styles from './UserClubs.module.scss';
import useHeader from '../../../hooks/useHeader';

const UserClubs = () => {
  const navigate = useNavigate()

  const [filter, setFilter] = useSearchParam<string, any>('filter')
  
  const profile = useUserStore(state => state.profile)
  
  const userId = getUserIdByPathname()

  const { data: user, isFetching: isFetchingUser } = useQuery(
    ['user'],
    () => getUser(userId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const {data: clubs, isFetching} = useQuery(
    ['user', 'clubs', filter],
    () => getAllUserClubs(userId, filter),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: user?.fullname, subheader: 'Clubes' });

  const addNewClub = (e) => {
    navigate('/club/add');
  }


  return (
      <div className={styles.container}>
        <HeaderPage header="Clubes" bageColor={main_color_50}/>
        <Filter>
          <FilterItem 
            onClick={e => setFilter('')} 
            active={filter === ''}>
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setFilter('admin')} 
            active={filter === 'admin'}>
              Criador
          </FilterItem>
          <FilterItem 
            active={filter === 'mediator'}
            onClick={e => setFilter('mediator')}> 
              Mediador
          </FilterItem>
          <FilterItem 
            active={filter === 'member'}
            onClick={e => setFilter('member')}>
              Clubista
          </FilterItem>
        </Filter> 
        <div className={styles.clubsContainer}>
          {clubs?.map(club => 
            <CustomClub clubId={club.clubId} key={club?.id}/>
          )}
        </div>
        { userId && profile !== 'Criador' ?
           <FloatButton onClick={addNewClub}/> 
          : null }
      </div>
  )
}

export default UserClubs;